// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1ckT5","list":"PatternAutocomplete_list__3Jl3u"};